import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export function nominate(nominateClubData, captchaToken) {
    return http.post(API_PATHS.nominateClub, nominateClubData, { headers: { 'g-recaptcha-response': captchaToken } });
}